import { apiService } from '@/shared/services/api';
import { endpoints } from '@/shared/services/endpoints';
import type { ApiResponse } from '@/shared/types/api';
import type {
  GoogleKeywordSuggestion,
  GoogleAudienceSuggestion,
  LocationTarget,
} from '../types/campaigns.types';

export async function searchGoogleKeywords(
  adAccountId: string | undefined,
  query: string,
): Promise<GoogleKeywordSuggestion[]> {
  const { data } = await apiService.get<ApiResponse<GoogleKeywordSuggestion[]>>(
    endpoints.adsGoogle.keywords(adAccountId, query),
  );
  return data.data;
}

/**
 * Google geo targets. Kept separate from the Meta-backed location search
 * because only these ids are valid Google campaign location criteria — and the
 * rows carry Google's own reach, which sharpens the audience estimate.
 */
export async function searchGoogleGeoTargets(
  adAccountId: string | undefined,
  query: string,
): Promise<LocationTarget[]> {
  const { data } = await apiService.get<ApiResponse<LocationTarget[]>>(
    endpoints.adsGoogle.geoTargets(adAccountId, query),
  );
  return data.data;
}

export async function searchGoogleAudiences(
  adAccountId: string | undefined,
  query: string,
  type?: 'USER_INTEREST' | 'AUDIENCE' | 'ALL',
): Promise<GoogleAudienceSuggestion[]> {
  const { data } = await apiService.get<ApiResponse<GoogleAudienceSuggestion[]>>(
    endpoints.adsGoogle.audiences(adAccountId, query, type),
  );
  return data.data;
}
